export const DEFAULT_NO_RECORDED_GUEST_NOTE_TEXT = 'Add Notes';
export const NAVIGATE_TO_COVER_FLOW_SEARCH_PARAMS_KEY = 'navigateToCoverFlow';
export const DATE_PARAM = 'date';

export const DRAWER_PARAM = 'drawer';

// Values for the DRAWER_PARAM
export const OCCUPANT_DETAILS = 'occupantDetails';
export const ADD_TO_WAITLIST = 'addToWaitlist';
export const VIEW_WAITLIST_ENTRY = 'viewWaitlistEntry';
export const SERVER_FORM = 'server';
export const SEAT_WAITLIST_GUEST = 'seatWaitlistGuest';
export const SEAT_WALK_IN_FORM = 'seatWalkInForm';
export const SEAT_RESERVATION_GUEST = 'seatReservationGuest';
export const STATS = 'stats';
export const SERVICE_OVERVIEW = 'serviceOverview';

export const OCCUPANT_ID_PARAM = 'occupantId';
export const OCCUPANT_TYPE_PARAM = 'occupantType';
export const SEAT_MODE_PARAM = 'seatMode';
export const EDIT_RESERVATION_MODE_PARAM = 'editReservationMode';
export const DATE_PARAM_FORMAT = 'yyyy-MM-dd';
export const WAITLIST_ENTRY_INDEX_PARAM = 'waitlistEntryIndex';
export const GUEST_SEARCH_PARAM = 'guestSearch';

export const DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

export const MONTHS = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
];

export const LEVEL_COLORS = [
  { label: 'low', color: '#4A453D' },
  { label: 'medium', color: '#7D6D52' },
  { label: 'high', color: '#B09667' },
];

export const CHART_HEIGHT = 200;
export const CHART_STYLES = {
  top: 20,
  right: 0,
  borderWidth: 5,
  bottom: 0,
  left: 0,
};
export const CHART_STYLES_BOTTOM_ROTATED = 70;
export const BAR_ANIMATION_DURATION = 300;
export const MIN_BAR_WIDTH = 60;
